import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowForward = () => {
  return (
    <g>
      <path d="m15.9035 7.7136a.75.75 0 0 0 -.1618-.2436l-6.0517-6.0518a.75.75 0 1 0 -1.06 1.0606l4.7709 4.7712h-7.02c-2.6695 0-4.8409-1.5237-4.8409-3.3972a.75.75 0 1 0 -1.5 0c0 2.7007 2.8443 4.8972 6.3414 4.8972h7.02l-4.7714 4.7712a.75.75 0 1 0 1.06 1.0606l6.0513-6.0513a.7527.7527 0 0 0 .1618-.8169z" />
    </g>
  );
};

export default withIcon(IconArrowForward);
